var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({class:[
    'inline-flex items-center justify-center transition-colors duration-300',
    _vm.sizeClasses,
    _vm.variantClasses,
    _vm.roundedClasses,
    {
      'opacity-50 cursor-not-allowed': _vm.disabled,
      'cursor-pointer': !_vm.disabled,
    },
    _vm.className,
  ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[(_vm.icon)?_c('i',{class:['mdi', `mdi-${_vm.icon}`, _vm.iconClasses]}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }